
export const pdfDownloadMap: Readonly<Record<string, string>> = Object.freeze({
  'animalandveterinarydrugevent': '/fields/animalandveterinaryevent_reference.pdf',
  'foodevent': '/fields/foodevent_reference.pdf',
  'foodenforcement': '/fields/foodenforcement_reference.pdf',
  'cosmeticevent': '/fields/cosmeticevent_reference.pdf',
  'drugevent': '/fields/drugevent_reference.pdf',
  'druglabel': '/fields/druglabel_reference.pdf',
  'drugndc': '/fields/drugndc_reference.pdf',
  'drugenforcement': '/fields/drugenforcement_reference.pdf',
  'drugsfda': '/fields/drugsfda_reference.pdf',
  'drugshortages': '/fields/drugshortages_reference.pdf',
  'drugorangebook': '/fields/drugshortages_reference.pdf',
  'deviceevent': '/fields/deviceevent_reference.pdf',
  'devicerecall': '/fields/devicerecall_reference.pdf',
  'deviceclass': '/fields/deviceclass_reference.pdf',
  'devicereglist': '/fields/devicereglist_reference.pdf',
  'deviceclearance': '/fields/deviceclearance_reference.pdf',
  'devicepma': '/fields/devicepma_reference.pdf',
  'deviceudi': '/fields/deviceudi_reference.pdf',
  'deviceenforcement': '/fields/deviceenforcement_reference.pdf',
  'covid19serology': '/fields/devicecovid19serology_reference.pdf',
  'otherhistoricaldocument': '/fields/otherhistoricaldocument_reference.pdf',
  'othernsde': '/fields/othernsde_reference.pdf',
  'othersubstance': '/fields/othersubstance_reference.pdf',
  'researchcovidmirnaandproteomics': '/fields/researchcovidmirnaandproteomics_reference.pdf',
  'researchtobaccopreventionads': '/fields/researchtobaccopreventionads_reference.pdf',
  'researchtobaccodigitalads': '/fields/researchtobaccodigitalads_reference.pdf',
  'researchtobaccosmokefree': '/fields/researchtobaccosmokefree_reference.pdf',
  'researchtobaccoharmmenthol': '/fields/researchtobaccoharmmenthol_reference.pdf',
  'tobaccoproblem': '/fields/tobaccoproblem_reference.pdf',
  'transparencycrl': '/fields/transparencycrl_reference.pdf'
})

export const xlsxDownloadMap: Readonly<Record<string, string>> = Object.freeze({
  'animalandveterinarydrugevent': '/fields/animalandveterinaryevent_reference.xlsx',
  'foodevent': '/fields/foodevent_reference.xlsx',
  'foodenforcement': '/fields/foodenforcement_reference.xlsx',
  'cosmeticevent': '/fields/cosmeticevent_reference.xlsx',
  'drugevent': '/fields/drugevent_reference.xlsx',
  'druglabel': '/fields/druglabel_reference.xlsx',
  'drugndc': '/fields/drugndc_reference.xlsx',
  'drugenforcement': '/fields/drugenforcement_reference.xlsx',
  'drugorangebook': '/fields/drugorangebook_reference.xlsx',
  'drugsfda': '/fields/drugsfda_reference.xlsx',
  'drugshortages': '/fields/drugshortages_reference.xlsx',
  'deviceevent': '/fields/deviceevent_reference.xlsx',
  'devicerecall': '/fields/devicerecall_reference.xlsx',
  'deviceclass': '/fields/deviceclass_reference.xlsx',
  'devicereglist': '/fields/devicereglist_reference.xlsx',
  'deviceclearance': '/fields/deviceclearance_reference.xlsx',
  'devicepma': '/fields/devicepma_reference.xlsx',
  'deviceudi': '/fields/deviceudi_reference.xlsx',
  'deviceenforcement': '/fields/deviceenforcement_reference.xlsx',
  'covid19serology': '/fields/devicecovid19serology_reference.xlsx',
  'otherhistoricaldocument': '/fields/otherhistoricaldocument_reference.xlsx',
  'othernsde': '/fields/othernsde_reference.xlsx',
  'othersubstance': '/fields/othersubstance_reference.xlsx',
  'researchcovidmirnaandproteomics': '/fields/researchcovidmirnaandproteomics_reference.xlsx',
  'researchtobaccopreventionads': '/fields/researchtobaccopreventionads_reference.xlsx',
  'researchtobaccodigitalads': '/fields/researchtobaccodigitalads_reference.xlsx',
  'researchtobaccosmokefree': '/fields/researchtobaccosmokefree_reference.xlsx',
  'researchtobaccoharmmenthol': '/fields/researchtobaccoharmmenthol_reference.xlsx',
  'tobaccoproblem': '/fields/tobaccoproblem_reference.xlsx',
  'transparencycrl': '/fields/transparencycrl_reference.xlsx'
})

export const yamlDownloadMap: Readonly<Record<string, string>> = Object.freeze({
  'animalandveterinarydrugevent': '/fields/animalandveterinaryevent.yaml',
  'foodevent': '/fields/foodevent.yaml',
  'foodenforcement': '/fields/foodenforcement.yaml',
  'cosmeticevent': '/fields/cosmeticevent.yaml',
  'drugevent': '/fields/drugevent.yaml',
  'druglabel': '/fields/druglabel.yaml',
  'drugndc': '/fields/drugndc.yaml',
  'drugenforcement': '/fields/drugenforcement.yaml',
  'drugorangebook': '/fields/drugorangebook.yaml',
  'drugsfda': '/fields/drugsfda.yaml',
  'drugshortages': '/fields/drugshortages.yaml',
  'deviceevent': '/fields/deviceevent.yaml',
  'devicerecall': '/fields/devicerecall.yaml',
  'deviceclass': '/fields/deviceclass.yaml',
  'devicereglist': '/fields/devicereglist.yaml',
  'deviceclearance': '/fields/deviceclearance.yaml',
  'devicepma': '/fields/devicepma.yaml',
  'deviceudi': '/fields/deviceudi.yaml',
  'deviceenforcement': '/fields/deviceenforcement.yaml',
  'covid19serology': '/fields/devicecovid19serology.yaml',
  'otherhistoricaldocument': '/fields/otherhistoricaldocument.yaml',
  'othernsde': '/fields/othernsde.yaml',
  'othersubstance': '/fields/othersubstance.yaml',
  'researchcovidmirnaandproteomics': '/fields/researchcovidmirnaandproteomics.yaml',
  'researchtobaccopreventionads': '/fields/researchtobaccopreventionads.yaml',
  'researchtobaccodigitalads': '/fields/researchtobaccodigitalads.yaml',
  'researchtobaccosmokefree': '/fields/researchtobaccosmokefree.yaml',
  'researchtobaccoharmmenthol': '/fields/researchtobaccoharmmenthol.yaml',
  'tobaccoproblem': '/fields/tobaccoproblem.yaml',
  'transparencycrl': '/fields/transparencycrl.yaml'
})